























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeReferensi } from "@/store/modules/referensi";
import { storeBed } from "@/store/modules/bed";

interface AutocompleteOptions {
  outlined: true;
  label: "";
}

@Component({
  components: {}
})
export default class UnitAutoComplete extends Vue {
  @Prop() setUnit!: object;
  @Prop() disUnit!: boolean;

  @Prop({
    default: () => {
      return {
        outlined: true,
        label: null
      };
    }
  })
  opt: AutocompleteOptions;

  get listUnit() {
    let bangsal = [];
    if (this.akses["unit_id"]) {
      if (this.akses["unit_id"] == "*") {
        bangsal = storeReferensi.unit;
      } else if (this.akses["unit_id"] == "59") {
        //yudhistira
        bangsal = storeReferensi.unit.filter(
          val =>
            val.id == "59" || val.id == "68" || val.id == "60" || val.id == "62"
        );
      } else if (this.akses["unit_id"] == "58") {
        //arjuna
        bangsal = storeReferensi.unit.filter(
          val => val.id == "58" || val.id == "71"
        );
      } else if (this.akses["unit_id"] == "50") {
        //wisnu & dewaruci
        bangsal = storeReferensi.unit.filter(
          val =>
            val.id == "5C" ||
            val.id == "50" ||
            val.id == "5A" ||
            val.id == "5B" ||
            val.id == "5F"
        );
      } else if (this.akses["unit_id"] == "5C") {
        //wisnu lt3
        bangsal = storeReferensi.unit.filter(
          val => val.id == "5C" || val.id == "50"
        );
      } else if (this.akses["unit_id"] == "5A") {
        //dewaruci(HCU / PICU)
        bangsal = storeReferensi.unit.filter(
          val => val.id == "5A" || val.id == "5B" || val.id == "5F"
        );
      } else if (this.akses["unit_id"] == "61") {
        //bima
        bangsal = storeReferensi.unit.filter(
          val => val.id == "61" || val.id == "69"
        );
      } else {
        bangsal = storeReferensi.unit.filter(
          val => val.id == this.akses["unit_id"]
        );
      }
    } else {
      bangsal = storeReferensi.unit;
    }
    return bangsal;
    // return storeReferensi.unit;
  }
  get akses() {
    return storeBed.akses;
  }

  unit = {};

  list = [];

  searchUnit = null;

  loading = false;

  @Watch("setUnit")
  valUnit(val) {
    this.$emit("unit", val);
  }
}
